import { render, staticRenderFns } from "./Selectoptions.vue?vue&type=template&id=05cb46ef&"
import script from "./Selectoptions.vue?vue&type=script&lang=js&"
export * from "./Selectoptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports